var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"s2",attrs:{"fluid":""}},[_c('v-container',{staticClass:"fontWhite"},[_c('p',[_vm._v(_vm._s(_vm.$t('landingpage.accessPriceText'))+" "),_c('b',[_c('PriceCurrency')],1)]),_c('Cta')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }